//--------------------------------------------------------------------------
// ▼ スクロールしたらクラスを付与 ▼
$(window).scroll(function () {
  var $main = $('#main_contents');
  if (!$main.length) return; // ← 追加：存在しないページ（/cart等）では処理しない

  var pos = $main.offset();
  if (!pos) return;

  if ($(this).scrollTop() > pos.top) {
    $('body').addClass('nav_active');
  } else {
    $('body').removeClass('nav_active');
  }
});

// ▲ スクロールしたらクラスを付与 ▲
//--------------------------------------------------------------------------

//--------------------------------------------------------------------------
// ▼ ハンバーガーメニュー ▼

$(function () {
  // ハンバーガーボタンをクリックしたらページを開く
  $('.toggle_btn').on('click', function () {
    $('body').toggleClass('open');
  });
  // ハンバーガーボタン内のリンクをクリックしたらページを閉じる
  $('.gloval-nav a').on('click', function () {
    $('body').removeClass('open');
  });
  // グローバルナビメニューのリンクをクリックしたらページを閉じる
  $('.gloval-nav ul li a').on('click', function () {
    $('body').removeClass('open');
  });
  // 背景をクリックしたらページを閉じる
  $('.hamburger_bg').on('click', function () {
    $('body').removeClass('open');
  });
});

// ▲ ハンバーガーメニュー ▲
//--------------------------------------------------------------------------

//--------------------------------------------------------------------------
// ▼ 固定ヘッダー対応 滑らかなアンカーリンク機能 ▼

$(function() {
  // 設定値
  const SCROLL_SPEED = 800; // スクロール速度（ミリ秒）
  const HEADER_OFFSET = 20; // ヘッダーの高さに追加するオフセット（px）
  
  // ヘッダーの高さを動的に取得する関数
  function getHeaderHeight() {
    const header = $('header');
    if (header.length) {
      return header.outerHeight() + HEADER_OFFSET;
    }
    return HEADER_OFFSET; // ヘッダーがない場合のデフォルト値
  }
  
  // 滑らかなスクロール関数
  function smoothScroll(target, speed = SCROLL_SPEED) {
    const headerHeight = getHeaderHeight();
    let position;
    
    if (target === '#' || target === '' || target === '#top') {
      // ページトップへのスクロール
      position = 0;
    } else {
      const targetElement = $(target);
      if (targetElement.length) {
        position = targetElement.offset().top - headerHeight;
      } else {
        return false; // 対象要素が見つからない場合は何もしない
      }
    }
    
    $('html, body').stop().animate({
      scrollTop: position
    }, speed, 'swing');
    
    return false;
  }
  
  // ページ内アンカーリンクのクリックイベント
  $(document).on('click', 'a[href^="#"]', function(e) {
    e.preventDefault();
    const href = $(this).attr('href');
    
    // 外部リンクや特殊なリンクを除外
    if (href === '#' || href.length <= 1) {
      smoothScroll('#top');
      return false;
    }
    
    smoothScroll(href);
    
    // ハンバーガーメニューが開いている場合は閉じる
    if ($('body').hasClass('open')) {
      $('body').removeClass('open');
    }
    
    return false;
  });
  
  // ページ読み込み時のアンカーリンク処理（別ページからのアンカーリンク対応）
  $(window).on('load', function() {
    // URLにハッシュが含まれている場合の処理
    const hash = window.location.hash;
    
    if (hash && hash.length > 1) {
      // 少し遅延させてからスクロール（ページの読み込み完了を待つ）
      setTimeout(function() {
        const targetElement = $(hash);
        if (targetElement.length) {
          const headerHeight = getHeaderHeight();
          const position = targetElement.offset().top - headerHeight;
          
          // 初期位置を調整してからアニメーション
          $('html, body').scrollTop(0);
          $('html, body').animate({
            scrollTop: position
          }, SCROLL_SPEED, 'swing');
        }
      }, 100);
    }
  });
  
  // URL変更時の処理（ブラウザの戻る/進むボタン対応）
  $(window).on('hashchange', function() {
    const hash = window.location.hash;
    if (hash && hash.length > 1) {
      smoothScroll(hash);
    }
  });
  
  // ヘッダーの高さが変わった時の対応（リサイズ時など）
  $(window).on('resize', function() {
    // リサイズ時に必要に応じて現在位置を調整
    const hash = window.location.hash;
    if (hash && hash.length > 1) {
      const targetElement = $(hash);
      if (targetElement.length) {
        const headerHeight = getHeaderHeight();
        const currentScroll = $(window).scrollTop();
        const targetPosition = targetElement.offset().top - headerHeight;
        
        // 現在のスクロール位置がターゲット要素の近くにある場合のみ調整
        if (Math.abs(currentScroll - targetPosition) < 100) {
          $('html, body').scrollTop(targetPosition);
        }
      }
    }
  });
});

// ▲ 固定ヘッダー対応 滑らかなアンカーリンク機能 ▲
//--------------------------------------------------------------------------

//--------------------------------------------------------------------------
// ▼ ハンバーガー内アコーディオン ▼

$(".ac_btn").on("click",function() {
  const question = $(this);
  const answer = $(this).next();

  question.toggleClass("active");
  answer.slideToggle(500);
});

// ▲ ハンバーガー内アコーディオン ▲
//--------------------------------------------------------------------------

//--------------------------------------------------------------------------
// ▼ .footer__content-topにコピー ▼

window.copyFooterContent = function() {
  try {
    var source = document.querySelector('.footer__content-top');
    var target = document.querySelector('.copy_footer__content');
    if (!source) return console.warn('copyFooterContent: source not found');
    if (!target) return console.warn('copyFooterContent: target not found');
    target.innerHTML = source.innerHTML;
    // Optional: copy over classes or attributes
    target.className = 'copy_footer__content ' + (source.className || '');
    console.info('copyFooterContent: copied content.');
  } catch (e) {
    console.error('copyFooterContent error', e);
  }
};

function runCopyAfterLoad() {
  if (typeof window.copyFooterContent !== 'function') {
    console.warn('copyFooterContent not defined');
    return;
  }
  try {
    window.copyFooterContent();
    // If copy target is still empty, retry once after 300ms
    var target = document.querySelector('.copy_footer__content');
    if (target && target.innerHTML.trim() === '') {
      setTimeout(function() {
        window.copyFooterContent();
      }, 300);
    }
  } catch (e) {
    console.error('runCopyAfterLoad error', e);
  }
}

if (document.readyState === 'complete') {
  runCopyAfterLoad();
} else {
  window.addEventListener('load', runCopyAfterLoad, { once: true });
}

// ▲ .footer__content-topにコピー ▲
//--------------------------------------------------------------------------

//--------------------------------------------------------------------------
// ▼ .acアコーディオン ▼

(function($){
  $(function() {
    $('.ac .kodomo').hide();
    // 名前空間付きで一度だけバインドして二重バインドを防ぐ
    $('.ac .oya').off('click.headerWorksAccordion').on('click.headerWorksAccordion', function(e) {
      e.preventDefault();
      // アニメーションの競合を防ぐため停止してからトグル
      var $trigger = $(this);
      var $panel = $trigger.next('.kodomo');
      $panel.stop(true, true).slideToggle(200);
      // クリックで active クラスをトグル
      $trigger.toggleClass('active');
    });
  });
})(jQuery);

// ▲ .acアコーディオン ▲
//--------------------------------------------------------------------------

//--------------------------------------------------------------------------
// ▼ 独自カート通知 ▼

(function () {
  function openCartNotification() {
    var cartNotificationDiv = document.querySelector('.cart-notification');
    if (cartNotificationDiv) cartNotificationDiv.classList.add('active');
  }

  function closeCartNotification() {
    var cartNotificationDiv = document.querySelector('.cart-notification');
    if (cartNotificationDiv) cartNotificationDiv.classList.remove('active');
  }

  function isOnCartPage() {
    return window.location && window.location.pathname === '/cart';
  }

  function initCartNotification() {
    document.addEventListener('click', function (e) {
      if (
        e.target &&
        (e.target.classList.contains('cart-notification-close') ||
          e.target.classList.contains('cart-notification__continue-shopping'))
      ) {
        closeCartNotification();
      }
    });

    if (isOnCartPage()) return;

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS?.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.source && String(event.source) !== 'product-form') return;
        openCartNotification();
      });
      return;
    }

    document.addEventListener('cart:updated', function () {
      openCartNotification();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartNotification);
  } else {
    initCartNotification();
  }
})();
// ▲ 独自カート通知 ▲
//--------------------------------------------------------------------------


//--------------------------------------------------------------------------
// ▼ ヘッダーカートバッジ ▼
(function () {
  var badgeSelector = '.cart-badge';
  var inFlight = null;

  function setBadgeCount(count) {
    var badges = document.querySelectorAll(badgeSelector);
    if (!badges.length) return;

    badges.forEach(function (el) {
      el.textContent = String(count);

      if (count > 0) {
        el.classList.remove('visually-hidden');
        el.removeAttribute('hidden');
      } else {
        el.classList.add('visually-hidden');
      }
    });
  }

  function fetchCartAndUpdateBadge() {
    if (inFlight) return inFlight;

    inFlight = fetch('/cart.js', {
      method: 'GET',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Failed to fetch /cart.js');
        return res.json();
      })
      .then(function (cart) {
        setBadgeCount(cart.item_count || 0);
        return cart;
      })
      .catch(function (err) {
        console.warn('cart badge update failed', err);
      })
      .finally(function () {
        inFlight = null;
      });

    return inFlight;
  }

  function initCartBadgeAutoUpdate() {
    fetchCartAndUpdateBadge();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      if (PUB_SUB_EVENTS.cartUpdate) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
          fetchCartAndUpdateBadge();
        });
      }
      if (PUB_SUB_EVENTS.cartError) {
        subscribe(PUB_SUB_EVENTS.cartError, function () {
          fetchCartAndUpdateBadge();
        });
      }
    }

    if (window.location && window.location.pathname === '/cart') {
      var root = document.querySelector('cart-items') || document.querySelector('main') || document;
      var timer = null;

      function scheduleRefresh() {
        clearTimeout(timer);

        timer = setTimeout(function () {
          fetchCartAndUpdateBadge();

          setTimeout(function () {
            fetchCartAndUpdateBadge();
          }, 700);
        }, 800);
      }

      root.addEventListener('change', function (e) {
        var t = e.target;
        if (!t) return;

        if (t.name === 'updates[]' || t.classList.contains('quantity__input') || t.closest('.quantity')) {
          scheduleRefresh();
        }
      });

      root.addEventListener('click', function (e) {
        var btn = e.target && e.target.closest ? e.target.closest('button, a') : null;
        if (!btn) return;

        if (btn.hasAttribute('data-index') || btn.name === 'update' || btn.name === 'remove') {
          scheduleRefresh();
        }
      });
    }

    document.addEventListener('cart:updated', function () {
      fetchCartAndUpdateBadge();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartBadgeAutoUpdate);
  } else {
    initCartBadgeAutoUpdate();
  }
})();